export default "__VITE_ASSET__BSVkr7ym__"